import { render, staticRenderFns } from "./DG.vue?vue&type=template&id=66ee1f79&"
import script from "./DG.vue?vue&type=script&lang=js&"
export * from "./DG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports